import { render } from "./OldGuys.vue?vue&type=template&id=5bf855b5&lang=pug"
import script from "./OldGuys.vue?vue&type=script&lang=ts"
export * from "./OldGuys.vue?vue&type=script&lang=ts"

import "./OldGuys.vue?vue&type=style&index=0&id=5bf855b5&lang=scss"
script.render = render

export default script